





















































import {
  defineComponent,
  useRouter,
  ref,
  computed,
  useFetch,
  useContext
} from '@nuxtjs/composition-api'
import { useI18n } from '~/compositions/i18n'
import { useDep } from '~/compositions/dependency-container'

import CBreadcrumbs from '~/components/shared/configurable/CBreadcrumbs.vue'
import CBadge from '~/components/shared/configurable/badge/CBadge.vue'
import CLink from '~/components/shared/configurable/link/CLink.vue'
import CCategorySelect from '~/components/shared/configurable/category/select/CCategorySelect.vue'

import DealersPreviewService from '~/services/dealers/preview/DealersPreviewService'
import SnackbarService from '~/services/snackbar/SnackbarService'

import { Breadcrumb } from '~/models/common/types'
import { DealerPrefecture } from '~/models/dealer/types'
import { Category } from '~/models/dealer/map/types'

import { handleError } from '~/utils/http'
import { debounce } from '~/utils/function'

import { DEBOUNCE_SLOWER } from '~/constants/debounce'

export default defineComponent({
  components: { CBreadcrumbs, CBadge, CLink, CCategorySelect },
  setup() {
    const { t } = useI18n()
    const router = useRouter()
    const dealersPreviewService = useDep(DealersPreviewService)
    const snackbarService = useDep(SnackbarService)
    const { app } = useContext()

    /**
     * ? initial dealers list fetching
     */

    const dealers = ref<DealerPrefecture[]>([])
    const categories = ref<Category[]>([])
    const category = ref([])

    useFetch(async () => {
      try {
        const {
          formattedData,
          categories: cat
        } = await dealersPreviewService.getDealersLocationsList('', [])

        dealers.value = formattedData
        categories.value = cat
      } catch (error) {
        handleError(error as any, snackbarService, app.$logger, t)
      }
    })
    /**
     * ? breadcrumps section
     */
    const breadcrumbs = computed<Breadcrumb[]>({
      get() {
        return [
          {
            text: t('dealers') as string,
            url: router.resolve({
              name: '__dealers'
            }).href
          }
        ]
      },
      set() {}
    })

    const dealersRoute = (dealer: DealerPrefecture) => {
      return router.resolve({
        name: '__dealers_list_generic',
        query: {
          pg: '1',
          q: filterQuery.value,
          sort: '',
          location: dealer.value.toString(),
          categories: category.value.join(',')
        }
      }).href
    }

    /**
     * ? filtering dealers section
     */

    const filterQuery = ref('')

    const handleUserInputSearch = () => {
      router.push({
        name: '__dealers_list_generic',
        query: {
          pg: '1',
          q: filterQuery.value,
          sort: '',
          categories: category.value.join(',')
        }
      })
    }

    const handleCategorySelect = async (evt: number[]) => {
      try {
        const {
          formattedData,
          categories: cat
        } = await dealersPreviewService.getDealersLocationsList(
          filterQuery.value,
          evt
        )
        dealers.value = formattedData
        categories.value = cat
      } catch (error) {
        handleError(error as any, snackbarService, app.$logger, t)
      }
    }

    const debouncedUserInputSearch = debounce(async (evt: string) => {
      try {
        const {
          formattedData,
          categories: cat
        } = await dealersPreviewService.getDealersLocationsList(
          evt,
          category.value
        )

        dealers.value = formattedData
        categories.value = cat
      } catch (error) {
        handleError(error as any, snackbarService, app.$logger, t)
      }
    }, DEBOUNCE_SLOWER)

    return {
      breadcrumbs,
      dealers,
      filterQuery,
      dealersRoute,
      categories,
      category,
      handleCategorySelect,
      handleUserInputSearch,
      debouncedUserInputSearch
    }
  }
})
